
<template>
    <div class="statistics-popup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>
        <div class="content" style="font-size:11px;">
            <div>
                <div class="half">
                    <div class="header_column">
                        {{ $tc('global.ui.hours').toUpperCase() }}
                    </div>
                    <div class="entry-header">
                            <b>{{ $t('global.menubar.roster') }}</b>
                        </div>
                    <div class="entry">
                        <div class="left_column">
                            (+) {{ $tc('global.ui.hours') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.plus/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry-split">
                        <div class="left_column">
                            (-) {{ $tc('global.ui.hours') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.minus/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry last">
                        <div class="left_column">
                            <b>{{ $t('shift.template.total') }}</b>
                        </div>
                        <div class="right_column">
                            <b>{{ (vars.total/1000/3600).toFixed(2) }} h</b>
                        </div>
                    </div>
                    <div class="entry-header">
                        <b>{{ $t('roster.view.holidays') }}</b>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            (+) {{ $t('roster.view.carryOverPreviousMonth') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.ftPrevPositive/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry-split">
                        <div class="left_column">
                            (-) {{ $t('roster.view.carryOverPreviousMonth') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.ftPrevNegative/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            (+) {{ $t('roster.comp.holidayHours') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.ft/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry-split">
                        <div class="left_column">
                            (-) {{ $t('workBalance.payroll.holidayCompensation') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.fta/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry">
                        <div class="left_column">
                            (+) {{ $t('workBalance.payroll.holidayBalance') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.ftaSumPositive/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry-split">
                        <div class="left_column">
                            (-) {{ $t('workBalance.payroll.holidayBalance') }}
                        </div>
                        <div class="right_column">
                            {{ (vars.ftaSumNegative/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div class="entry last">
                        <div class="left_column">
                            <b>{{ $t('shift.template.total') }}</b>
                        </div>
                        <div class="right_column">
                            <b>{{ (vars.ftaSum/1000/3600).toFixed(2) }} h</b>
                        </div>
                    </div>
                    <div class="header_column" style="margin-top: 12px;">
                        {{ $t('roster.view.keyFigureProductivity').toUpperCase() }}
                    </div>
                    <div v-for="indicator in vars.indicators.filter(i => i.sumBehavior == 1)" v-bind:key="indicator.indicatorType.id" class="entry">
                        <div class="entry-header">
                            <b>{{ indicator.indicatorType.name + ' ' + $t('roster.view.productivity') }}</b>
                        </div>
                        <div class="entry">
                            <div class="left_column">
                                {{ $t('roster.view.plan') }}
                            </div>
                            <div class="right_column">
                                {{ ((indicator.plannedSum/Math.pow(10, indicator.indicatorType.fractional)) / (vars.productive / 1000 / 60 / 60)).toFixed(2) }}
                            </div>
                        </div>
                        <div class="entry-split last" v-if="indicator.currentMonth">
                            <div class="left_column">
                                {{ $t('workBalance.summary.actual') }} ({{ $t('roster.view.untilToday') }})
                            </div>
                            <div class="right_column">
                                {{ ((indicator.actualUntilTodaySum/Math.pow(10, indicator.indicatorType.fractional)) / (vars.productiveUntilNow / 1000 / 60 / 60)).toFixed(2) }}
                            </div>
                        </div>
                        <div class="entry-split last" v-else>
                            <div class="left_column">
                                {{ $t('workBalance.summary.actual') }}
                            </div>
                            <div class="right_column">
                                {{ ((indicator.actualSum/Math.pow(10, indicator.indicatorType.fractional)) / (vars.productive / 1000 / 60 / 60)).toFixed(2) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="half">
                    <div class="header_column">
                        {{ $t('roster.view.keyFigures').toUpperCase() }}
                    </div>
                    <div v-for="indicator in vars.indicators" v-bind:key="indicator.indicatorType.id" class="entry">
                        <div class="entry-header">
                            <b>{{ indicator.indicatorType.name }}</b>
                        </div>
                        <div class="entry">
                            <div class="left_column">
                                {{ $t('roster.view.plan') }}
                            </div>
                            <div class="right_column">
                                {{ (indicator.plannedSum/Math.pow(10, indicator.indicatorType.fractional)).toFixed(2) }}
                            </div>
                        </div>
                        <div v-if="indicator.currentMonth" class="entry-split-light dimmed">
                            <div class="left_column">
                                {{ $t('roster.view.untilToday') }}
                            </div>
                            <div class="right_column">
                                {{ (indicator.plannedUntilTodaySum/Math.pow(10, indicator.indicatorType.fractional)).toFixed(2) }}
                            </div>
                        </div>
                        <div v-bind:class="{entry: indicator.currentMonth, 'entry-split': !indicator.currentMonth}">
                            <div class="left_column">
                                {{ $t('workBalance.summary.actual') }}
                            </div>
                            <div class="right_column">
                                {{ (indicator.actualSum/Math.pow(10, indicator.indicatorType.fractional)).toFixed(2) }}
                            </div>
                        </div>
                        <div v-if="indicator.currentMonth" class="entry-split dimmed">
                            <div class="left_column">
                                {{ $t('roster.view.untilToday') }}
                            </div>
                            <div class="right_column">
                                {{ (indicator.actualUntilTodaySum/Math.pow(10, indicator.indicatorType.fractional)).toFixed(2) }}
                            </div>
                        </div>
                        <div class="entry" v-bind:class="{last: !indicator.currentMonth}">
                            <div class="left_column">
                                <i><b>{{ $t('roster.view.difference') }}</b></i>
                            </div>
                            <div class="right_column">
                                <i><b>{{ ((indicator.actualSum - indicator.plannedSum)/Math.pow(10, indicator.indicatorType.fractional)).toFixed(2) }}</b></i>
                            </div>
                        </div>
                        <div v-if="indicator.currentMonth" class="entry last dimmed">
                            <div class="left_column">
                                <i><b>{{ $t('roster.view.untilToday') }}</b></i>
                            </div>
                            <div class="right_column">
                                <i><b>{{ ((indicator.actualUntilTodaySum - indicator.plannedUntilTodaySum)/Math.pow(10, indicator.indicatorType.fractional)).toFixed(2) }}</b></i>
                            </div>
                        </div>
                    </div>
                    <div class="header_column" v-if="vars.projectTimes.length > 0">
                        {{ $t('roster.view.projects').toUpperCase() }}
                    </div>
                    <div v-for="projectTime in vars.projectTimes" v-bind:key="projectTime.id" class="entry">
                        <div class="entry-header">
                            <b>{{ projectTime.name }}</b>
                        </div>
                        <div class="entry">
                            <div class="left_column">
                                {{ $t('roster.view.plan') }}
                            </div>
                            <div class="right_column">
                                {{ (projectTime.planned/1000/3600).toFixed(2) }} h
                            </div>
                        </div>
                        <div class="entry">
                            <div class="left_column">
                                {{ $t('workBalance.summary.actual') }}
                            </div>
                            <div class="right_column">
                                {{ (projectTime.actual/1000/3600).toFixed(2) }} h
                            </div>
                        </div>
                    </div>
                    <div class="header_column">
                        {{ $t('shift.main.laborCosts').toUpperCase() }}
                    </div>
                    <!-- <div class="entry-header">
                        <b>Löhne laut Vertrag</b>
                    </div> -->
                    <div class="entry last">
                        <div class="left_column">
                            <b>{{ $t('roster.view.totalWages') }}</b>
                        </div>
                        <div class="right_column">
                            <b>{{ '€ ' + (vars.compensation).toFixed(2) }}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'statisticspopup',
        components: {
        },
        data(){
            return{
                toggled: false,
                elRelative: null,
                events: [],
                posx: 0,
                posy: 0,
                employee: null,
                mode: 0,
                planRange: "",
                istRange: "",
            }
        },
        created () {
        },
        destroyed(){
        },
        computed: {

            vars() {
                let v = {};
                let projectMap = this.$parent.projectMap;
                let plannedActual = this.$parent.employeePlannedActual;
                let indicators = this.$parent.allPlanningIndicators;
                v.indicators = Object.values(indicators);

                // calculate hours sums
                let plus = 0;
                let minus = 0;
                let plusMinusTotal = 0;
                let productive = 0;
                let productiveUntilNow = 0;
                
                v.ftPrevPositive = 0;
                v.ftPrevNegative = 0;
                
                v.ft = 0;
                v.fta = 0;
                v.ftaPositive = 0;
                v.ftaNegative = 0;
                
                v.ftaSumPositive = 0;
                v.ftaSumNegative = 0;
                
                let projectTimeMap = {};
                Object.values(plannedActual).forEach((elem)=>{
                    
                    let total = elem.total;
                    plusMinusTotal += total;
                    if(total >= 0){
                        plus += total;
                    }else{
                        minus += total;
                    }
                    productive += elem.sumWorkTimeProduktiv;
                    productiveUntilNow += elem.sumWorkTimeProduktivUntilNow;

                    v.ft += (elem.sumFtWorkTime + elem.ftaTime);
                    v.fta += elem.ftaTime
                    
                    elem.sumFtWorkTime > 0 ? (v.ftaPositive += elem.sumFtWorkTime) : (v.ftaNegative += elem.sumFtWorkTime);
                    elem.deltaFtWorkTime > 0 ? (v.ftPrevPositive += elem.deltaFtWorkTime) : (v.ftPrevNegative += elem.deltaFtWorkTime);
                    (elem.sumFtWorkTime + elem.deltaFtWorkTime) > 0 ? (v.ftaSumPositive += (elem.sumFtWorkTime + elem.deltaFtWorkTime)) : (v.ftaSumNegative += (elem.sumFtWorkTime + elem.deltaFtWorkTime));


                    if(elem.projectTimeMap != null){
                        Object.values(elem.projectTimeMap).forEach(pe => {
                            if(projectMap[pe.id]){
                                if(!projectTimeMap[pe.id]){
                                    projectTimeMap[pe.id] = {id: pe.id, name: projectMap[pe.id].name, planned: 0, actual: 0}
                                }
                                projectTimeMap[pe.id].planned += pe.planned;
                                projectTimeMap[pe.id].actual += pe.actual;
                            }
                        })
                    }
                });
                v.plus = plus;
                v.minus = minus;
                v.total = plusMinusTotal;
                v.productive = productive;
                v.productiveUntilNow = productiveUntilNow;
                v.ftaSum = v.ftaSumPositive + v.ftaSumNegative;
                v.projectTimes = Object.values(projectTimeMap);
                
                // monhtly compensation sum
                let compensation = this.$parent.GetMonthlyCompensationSum();
                v.compensation = compensation;
                //console.log('STATS VARS');
                //console.log(v);
                return v;
            }
        },
        methods: {
            Close(){
                //if($(window.mouse.element).closest('.statistics-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(elRelative){
                this.toggled = true;
                if(elRelative){
                    this.elRelative = elRelative
                    this.Reposition();
                }
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    view.posx = box.left + box.width + 5;
                    view.posy = box.top + 24;
                    view.$forceUpdate();
                });
            },
        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .statistics-popup{
        position:fixed;
        display:inline-block;
        max-height: 650px;
        width: 500px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: var(--bg);
        color: var(--col-label-default);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 15px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

    .statistics-popup .half{
        width: 50%;
        padding: 0px 10px;
    }

    .statistics-popup .entry{
        margin-top: 0px;
    }

    .statistics-popup .entry.dimmed{
        color: var(--contrast-5) !important;
        margin-top: -2px;
        font-size: 10px;
    }

    .statistics-popup .entry-split-light.dimmed{
        color: var(--contrast-5) !important;
        margin-top: -2px;
        font-size: 10px;
    }

    .statistics-popup .entry.last{
        margin-bottom: 8px;
    }

    .statistics-popup .entry-split.last{
        margin-bottom: 8px;
    }

    .statistics-popup .entry-split{
        border-bottom: 1px solid var(--contrast-4);
        padding-bottom: 2px; 
        margin-bottom: 2px !important;
    }

    .statistics-popup .entry-split-light{
        border-bottom: 0.5px solid var(--contrast-1);
        padding-bottom: 1px; 
        margin-bottom: 1px !important;
    }

    .statistics-popup .entry-header{
        border-bottom: 1px solid var(--contrast-4);
        padding-bottom: 2px; 
        margin-bottom: 2px;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

    .header_column {
        color: var(--md);
        display:inline-block;
        width: 100%;
        padding-bottom: 2px; 
        margin-bottom: 6px;
        font-weight: bold !important;
        border-bottom: 2px solid var(--md);
    }

    .left_column {
        display:inline-block; width: 100px; text-align:left;
    }
    .right_column {
        display:inline-block; width: 100px; text-align:right;
    }

</style>
